<template>
    <div class="h-screen w-screen ">
    
        <div class=" h-full w-full flex align-items-center justify-content-center">
            <Button  @click="sair" label="Clique para sair do app" icon="pi pi-sign-out" size="large" />
    </div>
    </div>
</template>
<script setup>
import { supabase } from '@/supabase';
import router from '@/router';
import Button from 'primevue/button';
import { useStore } from 'vuex';

const store = useStore();


const sair = async () => {
    store.commit('setLoading', true)
    store.commit('setUserSession', null);
    const { error } = await supabase.auth.signOut();
    if (error || store.state.userSession != null) {
        store.commit('setLoading', false)
        alert("Ocorreu um erro ao sair")
        return
    }
    store.dispatch('updatePaginaFazerLogin', true)
    store.commit('setLoading', false)
    router.push('/')
}

</script>